'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["placement", "hasPermission", "disabled", "messageKey"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const PermissionsTooltip = ({
  placement = 'left',
  hasPermission = true,
  messageKey = 'permissions.disallowed',
  children
}) => /*#__PURE__*/_jsx(Tooltip, {
  placement: placement,
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: messageKey
  }),
  disabled: hasPermission,
  children: children
});
export default (Wrapped => props => {
  const {
      placement = 'left',
      hasPermission = true,
      disabled = false,
      messageKey = 'permissions.disallowed'
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(PermissionsTooltip, {
    placement: placement,
    messageKey: messageKey,
    hasPermission: hasPermission,
    children: /*#__PURE__*/_jsx(Wrapped, Object.assign({}, rest, {
      disabled: !hasPermission || disabled
    }))
  });
});